export default "__VITE_ASSET__hbXfzjhJ__"